import { createContext } from 'react'
import { inventoryType, inventoryTypeEnum } from '../config'

export const TypeContext = createContext({
  type: inventoryTypeEnum.IN,
  no: null,
  stockType: '',
})
